<template>
  <div class="draggable-runtime" :class="{'DNPleft':isDNP}">
    <div
      class="list-component-item"
      :class="{'DNPleft':isDNP}"
      v-for="component in component.children"
      :key="component.id"
      :style="{display:(component.properties.hidden&&!component.properties.seat) || component.properties.OCHidden?'none':'block',visibility:component.properties.seat&&component.properties.hidden?'hidden':'visible'}">
      <component
        ref="children"
        :is="component.componentType"
        :component="component"
        :value="getChildrenData(component)"
        :parentPath="getCurrentPath()"
        :disabled="disabled"
        :labelParameter="getLabelParameter(component)"
        :eventBus="eventBus"
        @input="(buildData) => updateChildValue(component.archive.columnId, buildData)"
        @initRelated="initRelated"
        @initDefaultValue="initDefaultValue"
        @calculation="(expression) => calculation(expression)">
      </component>
    </div>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import Vue from 'vue'
import {containerInitMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, defaultValueMixin} from './mixins'
import {ruleGenerator} from './rule'
import RcInput from './rc-input.vue'
import RcNumeric from './rc-numeric.vue'
import RcTable from './rc-table.vue'
import RcAddress from './rc-address.vue'
import RcPhone from './rc-phone.vue'
import RcCurrency from './rc-currency.vue'
import RcDate from './rc-date.vue'
import RcTextarea from './rc-textarea.vue'
import RcLabel from './rc-label.vue'
import RcRadio from './rc-radio.vue'
import RcCheckbox from './rc-checkbox.vue'
import RcUuid from './rc-uuid.vue'
import RcRichBox from './rc-rich-box.vue'
import RcCombobox from './rc-combobox.vue'
import RcCoding from './rc-coding.vue'
import RcFlowingWater from './rc-flowing-water.vue'
import RcDataSource from './rc-data-source.vue'
import RcIdCard from './rc-id-card.vue'
import RcChildrenInput from './rc-children-input.vue'
import RcHyperlink from './rc-hyperlink.vue'
import RcCalTime from './rc-cal-time.vue'
import RcPassword from './rc-password.vue'
import RcLoginUser from './rc-login-user.vue'
import RcContentTable from './rc-content-table.vue'
import RcUpload from './rc-upload.vue'
import RcButton from './rc-button.vue'
import RcMember from './rc-member.vue'
import RcOcr from './rc-ocr.vue'
import RcRate from './rc-rate.vue'
import RcSwitch from './rc-switch.vue'
import RcReport from './rc-report.vue'
import RcBigFileUpload from './rc-big-file-upload.vue'
import RcImage from './rc-image.vue'
import RcTimeInterval from './rc-time-interval.vue'
import RcCascader from './rc-cascader.vue'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'rc-draggable',
  mixins: [componentMixin, containerMixin, calculationMixin, relFunMixin, ruleGenerator, defaultValueMixin, containerInitMixin],
  props: ['component', 'value', 'disabled', 'parentComponent', 'dialogWidth'],
  inject: ['formArgs'],
  data () {
    return {
    }
  },
  components: {
    RcInput,
    RcNumeric,
    RcTable,
    RcAddress,
    RcPhone,
    RcUuid,
    RcCurrency,
    RcDate,
    RcTextarea,
    RcLabel,
    RcRadio,
    RcCheckbox,
    RcRichBox,
    RcCombobox,
    RcCoding,
    RcFlowingWater,
    RcDataSource,
    RcIdCard,
    RcChildrenInput,
    RcHyperlink,
    RcCalTime,
    RcPassword,
    RcLoginUser,
    RcContentTable,
    RcUpload,
    RcButton,
    RcMember,
    RcOcr,
    RcRate,
    RcSwitch,
    RcReport,
    RcBigFileUpload,
    RcImage,
    RcTimeInterval,
    RcCascader
  },
  created () {
    this.loadComponent()
  },
  methods: {
    loadComponent () {
      sdk.components && sdk.components.RuntimeArr && sdk.components.RuntimeArr.forEach(n => {
        Vue.component(
          n.name,
          () => Promise.resolve(n.component)
        )
      })
    },
    initRelated (component, callback) {
      this.$emit('initRelated', component, callback)
    },
    initDefaultValue (component, callback) {
      this.$emit('initDefaultValue', component, callback)
    }
  },
  computed: {
    // 判断是否德恩普
    isDNP () {
      return CookieOperation.get('tenantId') === '1697A174-CB10-0E49-816E-5B98E44F2F33'
    },
    getLabelParameter () {
      return component => {
        /* 这个可能以后还需要，先注释
        // 一个字为14px像素
        let x = 14
        let width = 0
        let isSmall = this.dialogWidth === 'small'
        // 最多为18个字
        if (name.length > 18) {
          width = 18 * x
        } else {
          // 大屏最小宽度为 100px 最多展示 6 个字
          // 小屏最小宽度为 80px 最多展示 5 个字
          if (name.length < 5) {
            width = isSmall ? 5 * x : 6 * x
          } else {
            width = name.length * x
          }
        }
        return width + 16 + 'px'
        */
        let showSlot
        let className
        let l = component.name.length
        /* eslint-disable */
        // 将单字节字符的长度算为0.5
        if (component.name.match(/[\x00-\xff]/g)) {
          l = l - Math.floor(component.name.match(/[\x00-\xff]/g).length / 2)
        }
        /* eslint-enable */
        let labelName
        if (this.dialogWidth === 'small') {
          showSlot = l > 5 && component.properties.sortType !== 'toTop' && component.properties.sortType !== 'hidden'
          className = l > 10 ? 'text-justify' : ''
          if (component.properties && component.properties.componentExplain) {
            labelName = l > 5 ? component.name.substr(0, 5) + '...' : component.name
          } else {
            labelName = l > 10 ? component.name.substr(0, 9) + '...' : component.name
          }
        } else {
          showSlot = l > 6 && component.properties.sortType !== 'toTop' && component.properties.sortType !== 'hidden'
          className = l > 12 ? 'text-justify' : ''
          if (component.properties && component.properties.componentExplain) {
            labelName = l > 5 ? component.name.substr(0, 5) + '...' : component.name
          } else {
            labelName = l > 12 ? component.name.substr(0, 11) + '...' : component.name
          }
        }
        if (component.properties && component.properties.required) {
          className += ' control-required'
        } else {
          if (showSlot) {
            className += ' text-letter-spacing'
          }
        }
        return {
          width: this.dialogWidth === 'small' ? 5 * 14 + 16 + 'px' : 6 * 14 + 16 + 'px',
          dialogWidth: this.dialogWidth,
          showSlot,
          className,
          labelName
        }
      }
    }
  }
}
</script>

<style lang="scss">
.draggable-runtime.DNPleft {
  .list-component-item.DNPleft {
    padding: 8px 2px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-form-item {
      margin: 0;
      .component-explain-tooltip {
        position: absolute;
        left: -9px;
        top: 8px;
      }
      .el-form-item__label {
        .control-label {
          font-size: 13px;
          white-space: pre-line;
          width: 100%;
          height: 28px;
          line-height: 15px;
          word-wrap: break-word;
          word-break: break-all;
          text-align: left;
        }
        .text-justify {
          text-align: justify;
        }
        .control-required {
          width: calc(100% - 2px);
        }
        .text-letter-spacing {
          letter-spacing: 1px;
          display: flex;
          align-items: center;
        }
      }
      .el-form-item__content{
        padding-left: 12px;
        .el-input.clear-padding,.el-select.clear-padding,.el-textarea.clear-padding{
          input,textarea{
            padding: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-draggable.vue